import clsx from 'clsx';
import { TemplateCard } from '../../../../../features/templates/ui/template-card';
import { formatTemplateModifiedLabel } from '../../../../../features/templates/ui/template-card/lib/formatTemplateModifiedLabel';
import { SpinnerWrap } from '../../../../../shared/ui/spinner';
import styles from '../TemplatesList.module.css';

export function TemplatesCardsGrid({
  items,
  showSpinner,
  onEditTemplate,
  onCopyTemplate,
  onPreviewTemplate,
  canEdit = false,
}) {
  if (showSpinner) {
    return <SpinnerWrap ariaLabel="Templates loading" />;
  }

  return (
    <div className={clsx(styles.cardsGrid)} aria-label="Templates grid">
      {items.map((item) => (
        <TemplateCard
          key={item.id}
          templateId={item.id}
          title={item.name}
          status={item.status}
          channel={item.channel}
          language={item.language}
          type={item.type}
          updatedLabel={formatTemplateModifiedLabel(item.modified)}
          tags={(item.tags ?? []).map((t) => t.name)}
          campaigns={(item.campaigns ?? []).map((a) => a.name)}
          trigger={item.triggers?.[0]?.trigger ?? null}
          showActions
          canEdit={canEdit}
          onEdit={() => onEditTemplate?.(item)}
          onCopy={() => onCopyTemplate?.(item)}
          onPreview={() => onPreviewTemplate?.(item)}
        />
      ))}
    </div>
  );
}
